@use 'sass:math';
@import '../../styles/mixins';
@import '../../styles/blaze/mixins';
@import '../../styles/variables';

/* stylelint-disable-next-line css-modules/no-global-scoped-selector */
:root {
  --activity-event-padding: 10px;
  --activity-event-margin: 10px;
  --activity-event-content-vertical-padding: 6px;
  --activity-event-tracker-margin: calc(var(--activity-event-margin) / -2);
}

.root {
  display: flex;
  padding: var(--activity-event-padding) var(--activity-event-padding) var(--activity-event-padding) 6px;
  position: relative;
  border-radius: 10px;
  margin-bottom: var(--activity-event-margin);
  margin-top: var(--activity-event-margin);
  cursor: pointer;

  &.static {
    cursor: default;
  }

  &.flash {
    animation-name: fade-in;
    animation-duration: 3s;
    animation-timing-function: ease-in-out;

    @keyframes fade-in {
      0% {
        background: $gold-10;
      }
      75% {
        background: $gold-10;
      }
      100% {
        background: var(--neutral-0);
      }
    }
  }

  &.informalFeedbackRequest {
    background-color: rgba(102, 78, 255, 0.03);
    border-radius: 8px;

    &.hovered {
      background-color: rgba(102, 78, 255, 0.07);
    }
  }
}

.selected {
  background: var(--neutral-0);
  box-shadow: 0 1px 6px 0 rgba(19, 21, 26, 0.08);
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: default;
}

.link {
  color: $blue-50;
  cursor: pointer;

  &:hover {
    color: $blue-60;
  }
}

.hovered {
  background: var(--neutral-3);

  .actions {
    opacity: 1;
  }
}

.leftRail {
  padding: var(--activity-event-content-vertical-padding) 0;

  &.middle {
    [data-autopilot-system-redesign='on'] & {
      margin-top: 4px;
    }

    &:before {
      @extend .tracker;
    }

    svg {
      position: relative;
    }
  }

  &.last {
    &:before {
      @extend .tracker;
      height: calc(
        var(--activity-event-padding) + var(--activity-event-content-vertical-padding) + var(--activity-event-margin) +
          4px
      );
    }

    &.merge {
      &:before {
        height: 12px;
      }
    }

    &.branch {
      &:before {
        height: 52px;
      }
    }
    &.loadMoreButton {
      &:before {
        top: -30px;
        height: 50px;
      }
    }
  }

  .icon {
    border-radius: 50%;
    position: relative;
    z-index: 1;
    display: block;
    width: 20px;
    height: 20px;

    [data-autopilot-system-redesign='on'] & {
      width: 10px;
      height: 10px;

      .circle {
        width: 10px;
        height: 10px;
        background: var(--dark-8);
        border-radius: 50%;
      }
    }
  }

  &.merge .icon,
  &.branch .icon {
    margin-left: 16px;
  }

  .mergeTrack {
    top: 4px;
    left: 15px;
    background: transparent;
    position: absolute;
    stroke: #eaecef;
  }

  .branchTrack {
    top: 36px;
    left: 15px;
    background: transparent;
    position: absolute;
    stroke: #eaecef;
  }

  .olderEventsIcon {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 16px;
    width: 10px;
    border: 2px solid var(--neutral-10);
    border-radius: 5px;
    margin-left: 5px;
    margin-right: 5px;
    padding: 2px 0;
    background: var(--neutral-0);

    .olderEventsIconDot {
      width: 2px;
      height: 2px;
      border-radius: 2px;
      background: $grey-10;
    }
  }
}

.tracker {
  content: '';
  position: absolute;
  width: 2px;
  left: 16px;
  background-color: #eaecef;
  top: var(--activity-event-tracker-margin);
  bottom: var(--activity-event-tracker-margin);

  [data-autopilot-system-redesign='on'] & {
    left: 10px;
    top: 14px;
  }
}

.main {
  flex: 1;
  @include md-regular;
}

.content {
  margin-left: 16px;
  display: grid;

  [data-ff-reviews-as-sharing='on'] & {
    margin-left: 6px;
  }
}

.contentText {
  padding-top: var(--activity-event-content-vertical-padding);
  color: var(--neutral-90);
  margin-bottom: 4px;
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row-start: 1;

  [data-autopilot-system-redesign='on'] & {
    @include xs-sohne-book;
    margin-bottom: 8px;
  }
}

.contentText::first-letter {
  text-transform: uppercase;
}

.name {
  color: var(--neutral-90);
  @include md-medium;
}

.collapseButton {
  display: inline-block;
  height: 16px;
  position: relative;
  top: 3px;
}

.timestamp {
  @include xs-sohne-book;
  color: var(--dark-60);

  [data-autopilot-system-redesign='on'] & {
    color: var(--dark-40);
  }
}

.buttons {
  margin-left: 8px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  column-gap: 16px;
  margin-bottom: 10px;
}

.nestedContent {
  margin-top: 16px;
}

.nestedRoot {
  display: flex;
  padding: 4px;
  margin-bottom: 4px;

  .contentText {
    margin-left: 8px;
  }
}

.actor {
  @include md-medium;
  color: var(--neutral-90);

  [data-autopilot-system-redesign='on'] & {
    @include xs-sohne-book;
  }
}

// We are using display grid here to make the actions overlap the content. The
// reason why we can't use position: absolute is that react-aria overlays do
// not position themselves correctly when using a trigger with absolute
// position.
.actions {
  display: flex;
  opacity: 0;
  column-gap: 6px;
  grid-row-start: 1;
  grid-column-end: 3;
  justify-content: flex-end;
}

.message {
  border: 1px solid var(--neutral-10);
  padding: 4px 8px;
  @include md-regular;
  color: var(--neutral-50);
  border-radius: 4px;
  margin-bottom: 8px;
  margin-left: 16px;
  background: var(--neutral-0);
  word-break: break-word;
  margin-left: 8px;

  :global(.ProseMirror) {
    color: var(--neutral-50);
  }

  [data-autopilot-system-redesign='on'] & {
    margin-bottom: 0;
    @include sm-sohne;
  }
}

.lastViewedContent {
  color: var(--selected-stroke);
  @include md-medium;
}

.lastViewedContainer {
  color: var(--selected-stroke);
}

.lastViewedToastWrapper {
  display: flex;
  justify-content: center;
  padding-top: 32px;
  position: absolute;
  right: 64px;
  left: 30px;
  z-index: 9999;
  bottom: 32px;
}

.lastViewedToast {
  background: $green-50;
  color: white;
  box-shadow: 0 1px 1px rgba(19, 21, 26, 0.12), 0 8px 24px rgba(19, 21, 26, 0.12);
  border-radius: 16px;
  padding: 0 16px 0 8px;
  height: 24px;
  display: flex;
  align-items: center;
  @include ui-sm-text;
  cursor: pointer;
  transition: transform 100ms ease-in-out;

  &:hover {
    transform: translateY(-2px);
  }

  svg {
    fill: white;
  }
}

.renameInput {
  border: 1px solid $green-50;
  border-radius: 4px;
  width: 100%;
  padding: 0 12px;
  line-height: 28px;

  &:focus {
    box-shadow: 0 0 0 3px rgba(0, 163, 158, 0.11);
  }
}

.loadMoreButtonText {
  color: var(--neutral-50);
  @include body-sm-text;
}

.statusWrapper {
  margin-top: 4px;
  margin-left: -8px;
}

.mergeIcon {
  color: var(--neutral-90);
}

.reviewIcon {
  border-radius: 50%;
  background-color: var(--dark-8);
  padding: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circleWrapper {
  width: 10px;
  height: 15px;
  background: var(--light-100);
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  margin-top: -5px;

  .circle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: var(--dark-8);
  }
}
